import { render, staticRenderFns } from "./MobileFooterNav.vue?vue&type=template&id=3cbff08b&scoped=true"
import script from "./MobileFooterNav.vue?vue&type=script&lang=js"
export * from "./MobileFooterNav.vue?vue&type=script&lang=js"
import style0 from "./MobileFooterNav.vue?vue&type=style&index=0&id=3cbff08b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbff08b",
  null
  
)

export default component.exports